export default "__VITE_PUBLIC_ASSET__bcad4cd6__"